import { Point } from './types';

/**
 * Round a number to the closest multiply of 'step'
 **/
export function round(step: number, num: number): number {
  const mod = step ? num % step : 0;
  return mod > step / 2 ? num - mod + step : num - mod;
}

/**
 * Limit a number between 2 values, inclusive
 */
export function clamp(min: number, max: number, num: number): number {
  return Math.min(max, Math.max(min, num));
}

/**
 *  Snap a number by distance to another number
 */
export function snap(to: number, dist: number, num: number): number {
  return Math.abs(num - to) <= dist ? to : num;
}

/**
 * Snap a number by distance every multiple of another number
 */
export function snapEvery(to: number, dist: number, num: number): number {
  const d1 = num % to;
  const d2 = to - (num % to);
  return d1 <= dist ? num - d1 : d2 <= dist ? num + d2 : num;
}

/**
 * Linear Interpulation
 * If t = 0 returns a, if t = 1 returns b, and transitions the value in-between
 */
export function lerp(a: number, b: number, t: number): number {
  return a * (1 - t) + b * t;
}

/**
 * Map a value from one range 'a' to different range 'b'
 */
export function mapRange(
  a1: number,
  a2: number,
  b1: number,
  b2: number,
  num: number,
): number {
  return ((num - a1) * (b2 - b1)) / (a2 - a1) + b1;
}

/**
 * Map a number from a range to a fraction between 0 and 1
 */
export function mapPercentage(start: number, end: number, num: number) {
  return mapRange(start, end, 0, 1, num);
}

/**
 * Get the distance between 2 points
 */
export function distance([x1, y1]: Point, [x2, y2]: Point): number {
  return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
}

export function deg2rad(angleInDeg: number): number {
  return (angleInDeg * Math.PI) / 180;
}

export function rad2deg(angleInRad: number): number {
  return (angleInRad * 180) / Math.PI;
}
